import { formatCurrency } from './format-currency'
import { truncateFloat } from './truncate-float'

const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const getConciliacaoPercentMessages = (valores) => {
  const { valorPago, valorGlosado, valorPagoConciliadoManual, valorPagoConciliadoAutomatico, valorGlosadoConciliadoManual, valorGlosadoConciliadoAutomatico } = valores
  const total = valorGlosado + valorPago

  const calculaPercentual = (valor, total) => {
    const diferenca = valor - total
    if (diferenca > -0.001) {
      return 1
    }

    return truncateFloat(valor / total, 4)
  }

  const formattedCurrencyTotal = formatCurrency(total)

  const formattedCurrencyPago = formatCurrency(valorPago)
  const formattedCurrencyGlosado = formatCurrency(valorGlosado)

  const valorPagoConciliado = valorPagoConciliadoAutomatico + valorPagoConciliadoManual
  const valorGlosadoConciliado = valorGlosadoConciliadoAutomatico + valorGlosadoConciliadoManual
  const formattedCurrencyPagoConciliado = formatCurrency(valorPagoConciliado)
  const formattedCurrencyGlosadoConciliado = formatCurrency(valorGlosadoConciliado)

  const valorPagoRestante = valorPago - valorPagoConciliado
  const valorGlosadoRestante = valorGlosado - valorGlosadoConciliado
  const formattedCurrencyPagoRestante = formatCurrency(valorPagoRestante)
  const formattedCurrencyGlosadoRestante = formatCurrency(valorGlosadoRestante)

  const formattedCurrencyPagoConciliadoManual = formatCurrency(valorPagoConciliadoManual)
  const formattedCurrencyPagoConciliadoAutomatico = formatCurrency(valorPagoConciliadoAutomatico)
  const formattedCurrencyGlosadoConciliadoManual = formatCurrency(valorGlosadoConciliadoManual)
  const formattedCurrencyGlosadoConciliadoAutomatico = formatCurrency(valorGlosadoConciliadoAutomatico)

  const formattedPercentPago = valorPago ? formatter.format(calculaPercentual(valorPago, total)) : '-%'
  const formattedPercentGlosado = valorGlosado ? formatter.format(calculaPercentual(valorGlosado, total)) : '-%'

  const formattedPercentPagoRestante = valorPago ? formatter.format(calculaPercentual(valorPagoRestante, valorPago)) : '-%'
  const formattedPercentGlosadoRestante = valorGlosado ? formatter.format(calculaPercentual(valorGlosadoRestante, valorGlosado)) : '-%'

  const formattedPercentPagoConciliado = valorPago ? formatter.format(calculaPercentual(valorPagoConciliado, valorPago)) : '-%'
  const formattedPercentGlosadoConciliado = valorGlosado ? formatter.format(calculaPercentual(valorGlosadoConciliado, valorGlosado)) : '-%'

  const formattedPercentPagoConciliadoManual = valorPago ? formatter.format(calculaPercentual(valorPagoConciliadoManual, valorPago)) : '-%'
  const formattedPercentPagoConciliadoAutomatico = valorPago ? formatter.format(calculaPercentual(valorPagoConciliadoAutomatico, valorPago)) : '-%'

  const formattedPercentGlosadoConciliadoManual = valorGlosado ? formatter.format(calculaPercentual(valorGlosadoConciliadoManual, valorGlosado)) : '-%'
  const formattedPercentGlosadoConciliadoAutomatico = valorGlosado ? formatter.format(calculaPercentual(valorGlosadoConciliadoAutomatico, valorGlosado)) : '-%'

  return {
    textPercentualPago: `${formattedCurrencyPago} pago de ${formattedCurrencyTotal} (${formattedPercentPago})`,
    textPercentualGlosado: `${formattedCurrencyGlosado} glosado de ${formattedCurrencyTotal} (${formattedPercentGlosado})`,
    textPercentualPagoConciliadoManual: `${formattedCurrencyPagoConciliadoManual} de ${formattedCurrencyPago} conciliados manualmente (${formattedPercentPagoConciliadoManual})`,
    textPercentualPagoConciliadoAutomatico: `${formattedCurrencyPagoConciliadoAutomatico} de ${formattedCurrencyPago} conciliados automaticamente (${formattedPercentPagoConciliadoAutomatico})`,
    textPercentualGlosadoConciliadoManual: `${formattedCurrencyGlosadoConciliadoManual} de ${formattedCurrencyGlosado} conciliados manualmente (${formattedPercentGlosadoConciliadoManual})`,
    textPercentualGlosadoConciliadoAutomatico: `${formattedCurrencyGlosadoConciliadoAutomatico} de ${formattedCurrencyGlosado} conciliados automaticamente (${formattedPercentGlosadoConciliadoAutomatico})`,
    textConciliadoPago: `${formattedCurrencyPagoConciliado} pago conciliado de ${formattedCurrencyPago} (${formattedPercentPagoConciliado})`,
    textConciliadoGlosado: `${formattedCurrencyGlosadoConciliado} glosado conciliado de ${formattedCurrencyGlosado} (${formattedPercentGlosadoConciliado})`,
    textRestantePago: `${formattedCurrencyPagoRestante} pago restante de ${formattedCurrencyPago} (${formattedPercentPagoRestante})`,
    textRestanteGlosado: `${formattedCurrencyGlosadoRestante} glosado restante de ${formattedCurrencyGlosado} (${formattedPercentGlosadoRestante})`
  }
}
